import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../lib/constants";
import { SEO } from "../../components/SEO";
import { Breadcrumbs, breadcrumbLd, GuideCard, GuideCta } from "../../components/guides/GuideParts";
import NotFound from "../NotFound";

export default function GuideCategory() {
  const { category } = useParams();
  const [cats, setCats] = useState(null);
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    axios.get(`${API}/guides/categories`).then(({ data }) => setCats(data.categories)).catch(() => setCats([]));
    axios.get(`${API}/guides`, { params: { category } }).then(({ data }) => setGuides(data)).catch(() => {});
  }, [category]);

  if (cats && !cats.find((c) => c.slug === category)) return <NotFound />;
  const cat = cats?.find((c) => c.slug === category);
  const crumbs = [{ label: "Accueil", to: "/" }, { label: "Guides fiscaux frontaliers", to: "/guides-fiscaux-frontaliers" }, { label: cat?.name || "", to: `/guides-fiscaux-frontaliers/${category}` }];

  return (
    <main data-testid="guide-category" className="pt-[76px]">
      {cat && <SEO title={cat.meta_title} description={cat.meta_description} path={`/guides-fiscaux-frontaliers/${category}`} jsonLd={[breadcrumbLd(crumbs)]} />}
      <section className="bg-[#F8F9FA] border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-10 pb-16">
          <Breadcrumbs items={crumbs} />
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#6B7280] mt-8 mb-4">Guides fiscaux frontaliers</p>
          <h1 data-testid="category-title" className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#0A1128] leading-[1.05]">{cat?.name}</h1>
          <p className="text-base md:text-lg text-[#4B5563] mt-6 leading-relaxed max-w-3xl">{cat?.description}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {guides.map((g, i) => <GuideCard key={g.slug} g={g} index={i} />)}
        </div>
        {guides.length === 0 && cats && <p className="text-sm text-[#6B7280]">Les guides de cette thématique arrivent prochainement.</p>}
        <div className="mt-12 flex flex-wrap gap-2">
          {(cats || []).filter((c) => c.slug !== category).map((c) => (
            <Link key={c.slug} to={`/guides-fiscaux-frontaliers/${c.slug}`} className="text-xs font-semibold text-[#4B5563] bg-white border border-[#C4C8CC]/60 rounded-full px-3 py-1.5 hover:border-[#0A1128] hover:text-[#0A1128] transition-colors duration-200">{c.name}</Link>
          ))}
        </div>
        <GuideCta />
      </section>
    </main>
  );
}
